export default __webpack_public_path__ + "static/media/org-program-registration-insights.2fb74a50.png";